import React from "react";
import { Mui } from "@osu/react-ui";

const styles = {
  width100: {
    width: "100%",
  },
  width50: {
    width: "50%",
  },
  listItemText: (theme) => ({
    flexBasis: "50%",
    display: "flex",
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(2),
  }),
  listItemLast: (theme) => ({
    flexBasis: "50%",
    display: "flex",
    alignItems: "center",
    paddingBottom: theme.spacing(2),
  }),
  dataList: {
    display: "flex",
    flexWrap: "wrap",
  },
};

const PreviousUniversity = (props) => {
  const { studentData } = props;

  function getSafeDate(date) {
    if (!date) { return "-"; }
    return (new Date(date)).toLocaleString().split(",")[0];
  }

  function getFromToDates(fromDate, toDate) {
    fromDate = getSafeDate(fromDate);
    toDate = getSafeDate(toDate);
    toDate = toDate?.trim()?.length && toDate !== "-" ? `- ${toDate}` : "";
    return `${fromDate} ${toDate}`;
  }

  const schools = studentData?.data?.universityInfo?.schools ?? [];
  const widthSx = schools.length === 1 ? styles.width100 : styles.width50;
 
  return schools.length > 0 ? (
    <React.Fragment>
      <Mui.Box sx={styles.width100}>
        <Mui.Typography style={{marginBottom: "1rem"}}>
          Cumulative GPA: {studentData?.data?.universityInfo?.cumGPA} <br/>
          Overall Attempted Hours: {studentData?.data?.attemptedHoursPU} <br/>
          Overall Earned Hours: {studentData?.data?.earnedHoursPU}
        </Mui.Typography>
        <Mui.Box sx={styles.dataList}>
          {schools.map(
            ({ name, city, state, completedUnits, attemptedUnits, cumGPA, fromDate, toDate }, index) => {
              return (
                <Mui.Box sx={widthSx} key={`${name}-${city}-${state}`}>
                  <Mui.List>
                  <Mui.ListItemText
                    key={`name-${index}`}
                    primary={name}
                    secondary={`${city} ${state}`}
                    sx={styles.listItemText}
                    primaryTypographyProps={{
                      component: "dt",
                      className: "margin-right-2",
                      variant: "subtitle2",
                    }}
                    secondaryTypographyProps={{
                      component: "dd",
                      variant: "body2",
                      color: "textPrimary",
                    }}
                  />
                  <Mui.ListItemText
                    key={`dates-${index}`}
                    primary={"Dates"}
                    secondary={`${getFromToDates(fromDate, toDate)}`}
                    sx={styles.listItemText}
                    primaryTypographyProps={{
                      component: "dt",
                      className: "margin-right-2",
                      variant: "subtitle2",
                    }}
                    secondaryTypographyProps={{
                      component: "dd",
                      variant: "body2",
                      color: "textPrimary",
                    }}
                  />
                  <Mui.ListItemText
                    key={`cumgpa-${index}`}
                    primary={"Cumulative GPA"}
                    secondary={`${cumGPA ?? "-"}`}
                    sx={styles.listItemText}
                    primaryTypographyProps={{
                      component: "dt",
                      className: "margin-right-2",
                      variant: "subtitle2",
                    }}
                    secondaryTypographyProps={{
                      component: "dd",
                      variant: "body2",
                      color: "textPrimary",
                    }}
                  />
                  <Mui.ListItemText
                    key={`completedUnits-${index}`}
                    primary={"Completed Units"}
                    secondary={completedUnits}
                    sx={styles.listItemText}
                    primaryTypographyProps={{
                      component: "dt",
                      className: "margin-right-2",
                      variant: "subtitle2",
                    }}
                    secondaryTypographyProps={{
                      component: "dd",
                      variant: "body2",
                      color: "textPrimary",
                    }}
                  />
                  <Mui.ListItemText
                    key={`attemptedUnits-${index}`}
                    primary={"Attempted Units"}
                    secondary={attemptedUnits}
                    sx={styles.listItemLast}
                    primaryTypographyProps={{
                      component: "dt",
                      className: "margin-right-2",
                      variant: "subtitle2",
                    }}
                    secondaryTypographyProps={{
                      component: "dd",
                      variant: "body2",
                      color: "textPrimary",
                    }}
                  />
                  </Mui.List>
                </Mui.Box>
              );
            }
          )}
        </Mui.Box>
      </Mui.Box>
    </React.Fragment>
  ) : (
    <></>
  );
};

export default PreviousUniversity;
